import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import * as ApexCharts from 'apexcharts';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';



declare var require: any;
var Highcharts = require('highcharts/highmaps.js');
var USA = require('@highcharts/map-collection/countries/us/us-all.geo.json');

@Component({
    selector: 'app-leads-analysis',
    templateUrl: './leads-analysis.component.html',
    styleUrls: ['./leads-analysis.component.scss']
})
export class LeadsAnalysisComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	graphSlideConfig = { slidesToShow: 2, slidesToScroll: 1, infinite: false, arrows: true, };
	user_details: any;

	@Input() selected_tab: any;
	@Input() stepper_stage: any;
	@Input() type: any;
	@Input() selected_opportunity_period: any;
	@Input() business_plan: any;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		private elementRef: ElementRef,
		private datePipe: DatePipe,
		private changeDetectorRef: ChangeDetectorRef,
	) { }

	ngOnInit(): void {
		window.scrollTo(0, 0);
		this.user_details = this.storageService.get("user_details");

		this.getPageSummary();

		// this.getOpportunitySummary();

		this.getStages();

		this.getDataTypeList();

		this.getStatus();
		this.getGenders();
		this.getAdvisorStatus();
		this.getStates();
    this.getRelationships();
		this.getProductGroups();
		this.getRegion();
		this.calculateYears();
		this.getBusinessPlan();

	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		c =
		k < 1
		? num.toFixed(0 + fixed)
		: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		d = c < 0 ? c : Math.abs(c),
		e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	back() {
		const data = {
			clickable: true,
			name: 'Summary',
		};
		// this.stateChanged.emit(data);
	}

	page_state: any = "Follow Up";
	changePageState(data) {
		if (data.clickable == true) {
			this.page_state = data.name;
			this.getPageSummary();
		}
	}

	page_summary_loaded: boolean = false;
	page_summary_data: boolean = false;
	getPageSummary() {
		this.page_summary_loaded = false;

		this.page_graph_data_loaded = false;

		let route: any = "/prospectfollowup/charts?business_plan_id=" + this.business_plan + "&opp_year=" + this.selected_opportunity_period;

		if (this.type == "New Prospects") {
			route = route + "&prospect_type=New Prospect";
		} else {
			route = route + "&prospect_type=New";
		}

    if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
     route = "/magidepositclientfollowup/charts?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type + "&opp_year=" + this.selected_opportunity_period;
    }

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_summary_data = res['data'];

				this.selected_high_value_leads = res["data"]["total_leads"];

				// this.getAnanlyticalSummary();

				// this.page_graph_data = res['data'];

				if (this.show_graphical_representation == true) {
					setTimeout(() => {
						this.createOppYearGraph();
						this.createCommunicationChannelActivityGraph();
						this.createMonthlyActivityGraph();

						this.getSourceGraph();
						this.getAgeTriggerGraph();
            			this.getDataTriggerGraph();
						this.getDateTriggerGraph();
						this.getAITriggerGraph();
						this.getPropensityScoreGraph();
						// this.getRegionGraph();


					}, 100);
				}

				// if (this.show_analysis == true) {
				// 	this.showAnalysis();
				// }

				// this.opportunity_graph_loaded = true;

				// this.getOpportunityGraph();

				this.getTableData();

				this.page_graph_data_loaded = true;

				this.page_summary_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.page_summary_loaded = true;
			},
		);
	}

	getKey(data, value) {
		return data[value];
	}

	selected_top_percentage: any = 100;
	selected_sale_type: any = "all";
	total_client_value: any = 0;
	total_aum_value: any = 0;
	total_wallet_share_value: any = "";
  	update_selected_high_value_leads: boolean = true;
	getOpportunitySummary() {
		// let type: any = "";
		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {
		// 		type = "Total Opportunities"
		// 	} else {
		// 		type = this.selected_sale_type;
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	type = "Up-Sell Opportunities";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	type = "Cross-Sell Opportunities";
		// } else if (this.type == "Upside Opportunities") {
		// 	type = "Upside Opportunities";
		// }
		this.commonService.getData("/salesprocessopportunity/" + this.selected_top_percentage + "/" + this.type + "?duration=" + this.selected_opportunity_period).subscribe(
			(res: any) => {
				this.total_client_value = res["total_clients"];
				this.total_aum_value = res["total_aum"];
				this.total_wallet_share_value = res["total_wallet_share"];

				this.selected_high_value_leads = this.total_client_value;

				this.page_graph_data = res;

				if (this.show_graphical_representation == true) {
					setTimeout(() => {
						this.getSourceGraph();
						this.getAgeTriggerGraph();
						this.getDataTriggerGraph();
						this.getDateTriggerGraph();
						this.getAITriggerGraph();
						this.getPropensityScoreGraph();
						// this.getRegionGraph();
					}, 100);
				}

				// this.opportunity_graph_loaded = true;

				this.getOpportunityGraph();

				this.getTableData();

				this.page_graph_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

	}

	selected_high_value_leads: any = 0;
	selected_analysis_value: any = 100;
	selected_client_value: any = 0;
	selected_aum_value: any = 0;
	selected_wallet_share_value: any = "";

	page_graph_data: any = {
		opportunity_graph: []
	};
	page_graph_data_loaded: boolean = false;

	opportunity_graph_loaded: boolean = false;

	getAnanlyticalSummary() {

		if (!this.selected_analysis_value) {
			this.selected_analysis_value = 10;
		}

		this.page_graph_data_loaded = false;
		// this.opportunity_graph_loaded = false;
		// let type: any = "";
		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {
		// 		type = "Total Opportunities"
		// 	} else {
		// 		type = this.selected_sale_type;
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	type = "Up-Sell Opportunities";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	type = "Cross-Sell Opportunities";
		// }


		this.commonService.getData("/salesprocessopportunitygraph/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + this.type + "?duration=" + this.selected_opportunity_period).subscribe(
			(res: any) => {

				this.total_client_value = res["total_clients"];
				this.total_aum_value = res["total_aum"];
				this.total_wallet_share_value = res["total_wallet_share"];

				this.selected_client_value = res["selected_total_clients"];

				// this.selected_client_value = res["selected_total_clients"];
				// this.selected_aum_value = res["selected_total_aum"];
				// this.selected_wallet_share_value = res["selected_wallet_share"];

				// if (this.update_selected_high_value_leads == true) {
				// 	// this.selected_high_value_leads = this.total_client_value;
				// 	this.selected_client_value = this.selected_high_value_leads;
				// 	this.update_selected_high_value_leads = false;
				// } else {
				// 	this.update_selected_high_value_leads = false;
				// }


				this.page_graph_data = res;

				if (this.show_graphical_representation == true) {
					setTimeout(() => {
						this.getSourceGraph();
						this.getAgeTriggerGraph();
            this.getDataTriggerGraph();
						this.getDateTriggerGraph();
						this.getAITriggerGraph();
						this.getPropensityScoreGraph();
						// this.getRegionGraph();


					}, 100);
				}

				// this.opportunity_graph_loaded = true;

				this.getOpportunityGraph();

				this.getTableData();

				this.page_graph_data_loaded = true;

			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.page_graph_data_loaded = true;
			},
		);
	}

	graph_request_progess: boolean = false;
	graph_request_queue: any = [];
	segregateGraphAPIData(data) {
		this.graph_request_queue.push(data);

		this.processGraphQueue();
	}

	graph_process_queue_data: any = [];
	processGraphQueue() {
		if (this.graph_request_progess || this.graph_request_queue.length == 0) {
			return;
		}

		this.graph_process_queue_data = this.graph_request_queue.shift();

		this.getOpportunityGraph();
	}

	getData() {
	}

	opportunity_graph_data: any;
	opportunity_recomendation_data: any;
	getOpportunityGraph() {
		// this.opportunity_graph_loaded = false;
		this.graph_request_progess = true;
		// let type: any = "";
		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {
		// 		type = "Total Opportunities"
		// 	} else {
		// 		type = this.selected_sale_type;
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	type = "Up-Sell Opportunities";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	type = "Cross-Sell Opportunities";
		// }
		// this.commonService.getData("/salesprocesspiegraph/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + type + "?duration=" + this.selected_opportunity_period).subscribe(
		// 	(res: any) => {
		// 		this.opportunity_graph_data = res['opportunity_graph'];
		// 		this.selected_client_value = res["selected_total_clients"];
		// 		setTimeout(() => {
		// 			this.createOpportunityGraph();
		// 			// if (!this.opportunuty_graph) {
		// 			// 	this.createOpportunityGraph();
		// 			// } else {
		// 			// 	this.updateOpportunityGraph(this.page_graph_data['opportunity_graph']['data'], this.page_graph_data['opportunity_graph']['legends']);
		// 			// }
		// 		}, 100);

		// 		if (this.selected_page_action.name != "") {
		// 			this.getTableData();
		// 		}


		// 		this.graph_request_progess = false;
		// 	},
		// 	(err) => {
		// 		this.commonService.showToast('error', err.error);
		// 		this.graph_request_progess = false;
		// 	},
		// );

		// const selected_top_percentage = this.graph_process_queue_data[0];
		// const selected_analysis_value = this.graph_process_queue_data[1];


		// this.commonService.getData("/salesprocesspiegraph/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + type + "?duration=" + this.selected_opportunity_period).subscribe(

		this.commonService.getData("/prospectspiegraphupdated/?business_plan_id=" + this.business_plan).subscribe(
			(res: any) => {
				// this.opportunity_graph_data = res['opportunity_graph'];
				this.opportunity_graph_data = res["graph_data"];
				this.opportunity_recomendation_data = res["recommendation"];
				// this.selected_client_value = res["selected_total_clients"];
				this.selected_client_value = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]["selected_total_clients"];

				// this.opportunity_graph_loaded = true;

				// setTimeout(() => {
				// 	this.createOpportunityGraph();
				// 	// if (!this.opportunuty_graph) {
				// 	// 	this.createOpportunityGraph();
				// 	// } else {
				// 	// 	this.updateOpportunityGraph(this.page_graph_data['opportunity_graph']['data'], this.page_graph_data['opportunity_graph']['legends']);
				// 	// }
				// }, 100);
				this.createOpportunityGraph();

				if (this.selected_page_action.name != "") {
					this.getTableData();
				}
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
			// complete: () => {
			//   this.graph_request_progess = false;
			//   this.processGraphQueue();
			// }
		);
	}

	opportunuty_graph_options: any;
	opportunuty_graph: any;
	createOpportunityGraph() {
		this.opportunity_graph_loaded = false;
		this.opportunity_graph_loaded = true;

		setTimeout(() => {
			let $this = this;
			if ($this.opportunuty_graph) {
				$this.opportunuty_graph.destroy();
				// $this.updateOpportunityGraph($this.opportunity_graph_data['data'], $this.opportunity_graph_data['legends']);
			}

			const options = {
				colors: $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['colors'],
				series: $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data'],
				chart: {
					type: 'pie',
					toolbar: {
						show: false,
					},
					zoom: {
						enabled: false,
					},
					height: 220,
				},
				noData: {
					text: 'No Data Available',
					align: 'center',
					verticalAlign: 'middle',
					offsetX: 0,
					offsetY: 0,
					style: {
						color: '#006AFF',
						fontSize: '24px',
						fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					},
				},
				plotOptions: {
					pie: {
						startAngle: 0
					}
				},
				dataLabels: {
					enabled: false,
				},
				labels: $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['legends'],
				legend: {
					position: 'bottom',
					enabled: false,
				},
				yaxis: {
					title: {
						text: '',
					},
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					custom: function ({ series, seriesIndex, dataPointIndex, w }) {
						return (
							'<div style="width:300px; padding:8px">' +
							'<p style="width:100%;text-overflow:clip;white-space:break-spaces">' +
							$this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['legends'][seriesIndex] +
							'</p>' +
							'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Opportunity</b>: $' +
							$this.commonService.abbreviateNumber($this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data'][seriesIndex]) + '(' + $this.opportunity_graph_data[$this.selected_top_percentage][$this.selected_analysis_value]['opportunity_graph']['data_percentage'][seriesIndex] + '% of Total Opportunity)' +
							'</p>' +
							'</div>'
						);
					},
					//  fixed: {
					//   enabled: true,
					//   position: "topRight"
					// }
				}
			};

			$this.opportunuty_graph = new ApexCharts(document.querySelector('#opportunity-graph'), options);
			$this.opportunuty_graph.render();

		}, 100);
	}

	updateOpportunityGraph(series, labels,) {
		this.opportunuty_graph.updateOptions({
			series: series,
			labels: labels
		});
		this.selected_high_value_leads = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]["selected_total_leads"];
		this.changeDetectorRef.detectChanges();
	}

	opportunitySliderChanged(event) {
		// this.selected_top_percentage = event.value;
		// const data = [event.value, this.selected_analysis_value];
		// this.segregateGraphAPIData(data);
		// this.getOpportunityGraph();

		this.selected_top_percentage = event.value;
		const series = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['data'];
		const labels = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['legends'];
		this.updateOpportunityGraph(series, labels);
	}

	opportunitySliderStopped() {
		// const data = [this.selected_top_percentage, this.selected_analysis_value];
		// this.segregateGraphAPIData(data);
		// this.getOpportunityGraph();

		const series = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['data'];
		const labels = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['legends'];
		this.updateOpportunityGraph(series, labels);

		// if (this.selected_page_action.name != "") {
		// 	this.getTableData();
		// }

		this.getTableData();

	}

	upsideOpportunitySliderChanged(event) {
		// this.selected_analysis_value = event.value;
		// const data = [this.selected_top_percentage, event.value];
		// this.segregateGraphAPIData(data);
		// this.getOpportunityGraph();

		this.selected_analysis_value = event.value;
		const series = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['data'];
		const labels = this.opportunity_graph_data[this.selected_top_percentage][this.selected_analysis_value]['opportunity_graph']['legends'];
		this.updateOpportunityGraph(series, labels);
	}

	validateSliderValue(event) {
		let value = event.target.value;

		const num = Number(value);

		if (num < 0) {
			event.target.value = 0;
		} else if (num > 100) {
			event.target.value = 100;
		}
	}

	page_summary_actions: any = [
		{
			name: "Contact Top Opportunities",
			description: "This action enables advisors to manually create or capture responses for the top selected opportunities for direct conversations",
			image: "assets/manual-task.png",
			background: "#A1C93E",
			action: "Note",
			action_type: "Manual Task",
		},
		{
			// name: "Capture Response",
			name: "Response from Automated Activity",
			description: "This action allows the advisors to capture the response of automated email activities for all opportunities",
			image: "assets/capture-response.png",
			background: "#EB9F2D",
			action: "Capture",
			action_type: "Capture Response",
		},
		{
			name: "Product Information",
			description: "This action allows the advisors to assign a product/ policy after sale is confirmed",
			image: "assets/product-information.png",
			background: "#55A1EF",
			action: "Add",
			action_type: "Product Information",
		}
	];

	selected_page_action: any = {
		name: ""
	};
	selectAction(data) {
		this.selected_page_action = data;
		this.selected_client = {
			id: ""
		};
		this.getTableData();
	}

	show_graphical_representation: boolean = false;
	toggleGraphs() {
		if (this.show_graphical_representation == true) {
			// this.getAnanlyticalSummary();
			this.getPageSummary();
		}
	}

	show_analysis: boolean = false;
	analysis_data: any;
	showAnalysis() {
		if (this.show_analysis == true) {

			let role: any = "";
			if (this.user_details.role.role == 4) {
				role = "Advisor Manager";
			} else if (this.user_details.role.role == 5) {
				role = "Advisor";
			} else if (this.user_details.role.role == 6) {
				role = "AFA";
			} else if (this.user_details.role.role == 8) {
				role = "Relationship Manager";
			}

			this.commonService.getData("/salesprocessanalysis/?role=" + role + "&opp_type=New" + "&opp_year=" + this.selected_opportunity_period).subscribe(
				(res: any) => {
					this.analysis_data = res;
					setTimeout(() => {
						this.createBreakdownChart();
						this.createRuleBasedBreakdownGraph();
						this.createAITrriggerBreakdownGraph();
					}, 200);
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	// opp_breakdown_id: any = "";
	// opp_breakdown_name: any = "";
	createBreakdownChart() {
		let $this = this;
		const options = {
			colors: $this.analysis_data["donout_graph"]["colors"],
			series: $this.analysis_data["donout_graph"]["data"],
			chart: {
				type: 'donut',
				events: {
					// mounted: function(chartContext, config) {
					// 	setTimeout(() => {
					// 		const svgNS = "http://www.w3.org/2000/svg";
					// 		const svgElement = chartContext.el.querySelector('.apexcharts-svg');
					// 		const rect = svgElement.getBoundingClientRect();

					// 		// Dynamically calculate the center based on the SVG dimensions
					// 		const centerX = rect.width / 2;
					// 		const centerY = rect.height / 2;

					// 		chartContext.w.config.series.forEach((value, i) => {
					// 			const angle = (i / chartContext.w.config.series.length) * 2 * Math.PI; // Simplified; for evenly spaced circles
					// 			const radius = Math.min(centerX, centerY) * 0.75; // 75% towards the edge of the SVG
					// 			const x = centerX + radius * Math.cos(angle);
					// 			const y = centerY + radius * Math.sin(angle);

					// 			// Create and append the circle
					// 			let circle = document.createElementNS(svgNS, "circle");
					// 			circle.setAttribute("cx", x.toString());
					// 			circle.setAttribute("cy", y.toString());
					// 			circle.setAttribute("r", "30"); // Circle radius
					// 			circle.setAttribute("fill", "white");
					// 			// circle.setAttribute("fill", $this.analysis_data["donout_graph"]["colors"][i]);
					// 			circle.setAttribute("stroke", "#D3D3D3");
					// 			// circle.setAttribute("stroke", "#FFFFFF");
					// 			circle.setAttribute("stroke-width", "1");
					// 			// circle.setAttribute("stroke-width", "2");
					// 			svgElement.appendChild(circle);

					// 			// Create and append the text, adjust as needed
					// 			let text = document.createElementNS(svgNS, "text");
					// 			text.setAttribute("x", x.toString());
					// 			text.setAttribute("y", (y + 5).toString()); // Slightly offset for text alignment
					// 			text.setAttribute("text-anchor", "middle");
					// 			text.setAttribute("alignment-baseline", "middle");
					// 			text.setAttribute("fill", "black");
					// 			text.textContent = $this.commonService.abbreviateNumber(value).toString();
					// 			svgElement.appendChild(text);
					// 		});
					// 	}, 100); // Delay to ensure chart is fully rendered
					// },
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.analysis_data["donout_graph"]['labels'][config.dataPointIndex],
							name: $this.analysis_data["donout_graph"]['labels'][config.dataPointIndex],
						};
						$this.opp_breakdown_id = details.id;
						$this.opp_breakdown_name = details.name;

						$this.current_pagination_page = 1;
						$this.getTableData();

					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 400,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			plotOptions: {
				pie: {
					// startAngle: 180,
					// endAngle: -180,
					donut: {
						size: '65%',
						labels: {
							show: true,
							total: {
								show: true,
								showAlways: true,
								label: 'Total',
								fontSize: '14px',
								fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
								fontWeight: 400,
								color: '#000000',
								formatter: function (w) {
									// Calculate the total value
									const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
									// Custom label to display
									return `${(total.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT))}`;
								}
							}
						}
					}
				}
			},
			dataLabels: {
				enabled: true,
				formatter(val, opts) {
					const data = $this.commonService.abbreviateNumber(opts.w.globals.series[opts.seriesIndex])
					return [data]
				},
			},
			labels: $this.analysis_data["donout_graph"]["labels"],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};
		var chart = new ApexCharts(document.querySelector("#breakdown-graph"), options);
		chart.render();
	}

	// rules_breakdown_id: any =  "";
	// rules_breakdown_name: any =  "";
	createRuleBasedBreakdownGraph() {
		let $this = this;
		var options = {
			colors: $this.analysis_data["rulebasedtree_graph"]["colors"],
			series: [
				{
					data: $this.analysis_data["rulebasedtree_graph"]["data"]
				}
		  	],
			dataLabels: {
				enabled: true,
				style: {
					colors: ['#000000'] // Specify your desired text color here
				},
			},
			legend: {
				show: false
			},
			chart: {
				height: 350,
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				type: 'treemap',
				events: {
					dataPointSelection: function(event, chartContext, config) {
						const details = {
							id: $this.analysis_data["rulebasedtree_graph"]['data'][config.dataPointIndex]['id'],
							name: $this.analysis_data["rulebasedtree_graph"]['data'][config.dataPointIndex]['x'],
						};
						$this.rules_breakdown_id = details.id;
						$this.rules_breakdown_name = details.name;

						$this.current_pagination_page = 1;
						$this.getTableData();

					}
				}
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			title: {
				text: ''
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:300px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['x'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Count:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['y'].toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Condition:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['condition'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description:</b> ' +
						$this.analysis_data["rulebasedtree_graph"]['data'][dataPointIndex]['description'] +
						'</p>' +
						'</div>'
					);
				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector("#rule-based-breakdown-graph"), options);
		chart.render();
	}

	// ai_breakdown_id: any =  "";
	// ai_breakdown_name: any =  "";
	createAITrriggerBreakdownGraph() {
		let $this = this;
		var options = {
			colors: $this.analysis_data["aibasedtree_graph"]["colors"],
			series: [
				{
					data: $this.analysis_data["aibasedtree_graph"]["data"]
				}
		  	],
			dataLabels: {
				enabled: true,
				style: {
					colors: ['#000000'] // Specify your desired text color here
				},
			},
			legend: {
				show: false
			},
			chart: {
				height: 350,
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				type: 'treemap',
				events: {
					dataPointSelection: function(event, chartContext, config) {
						const details = {
							id: $this.analysis_data["aibasedtree_graph"]['data'][config.dataPointIndex]['id'],
							name: $this.analysis_data["aibasedtree_graph"]['data'][config.dataPointIndex]['x'],
						};
						$this.ai_breakdown_id = details.id;
						$this.ai_breakdown_name = details.name;

						$this.current_pagination_page = 1;
						$this.getTableData();

					}
				}
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			title: {
				text: ''
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					return (
						'<div style="width:300px; padding:8px">' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['x'] +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Count:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['y'].toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT) +
						'</p>' +
						'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description:</b> ' +
						$this.analysis_data["aibasedtree_graph"]['data'][dataPointIndex]['description'] +
						'</p>' +
						'</div>'
					);
				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector("#ai-triggers-breakdown-graph"), options);
		chart.render();
	}

	opp_year_name: any = '';
	opp_year_id: any = '';
	createOppYearGraph() {
		let $this = this;
		var options = {
		// colors: ["#5EDEC7"],
		series: [
			{
				name: '',
				data: $this.page_summary_data['yearly_opp']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['yearly_opp']['x-axis'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['yearly_opp']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.opp_year_id =
				$this.opp_year_id == details.id ? '' : details.id;
				$this.opp_year_name =
				$this.opp_year_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('opp-year-graph').clientWidth,
				$this.page_summary_data['yearly_opp']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['yearly_opp']['x-axis'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#opp-year-graph'),
		options,
		);
		chart.render();
	}

	createCommunicationChannelActivityGraph() {
		// let $this = this;
		// var options = {
		//   // colors: ["#D3D3D3", "#55A1EF"],
		// //   colors: ['#1B82EC', '#FFA724', '#91C906'],
		//   series: $this.page_summary_data['activity_comms']['y-axis'],
		//   chart: {
		// 	type: 'bar',
		// 	toolbar: {
		// 	  show: false,
		// 	},
		// 	zoom: {
		// 	  enabled: false,
		// 	},
		// 	height: 300,
		//   },
		//   noData: {
		// 	text: 'No Data Available',
		// 	align: 'center',
		// 	verticalAlign: 'middle',
		// 	offsetX: 0,
		// 	offsetY: 0,
		// 	style: {
		// 	  color: '#006AFF',
		// 	  fontSize: '24px',
		// 	  fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
		// 	},
		//   },
		//   plotOptions: {
		// 	bar: {
		// 	  horizontal: false,
		// 	  columnWidth: $this.commonService.getBarGraphPercentWidth(
		// 		document.getElementById('communication-channel-activities-graph').clientWidth,
		// 		$this.page_summary_data['activity_comms']['x-axis'].length,
		// 		30,
		// 	  ),
		// 	  endingShape: 'rounded',
		// 	},
		//   },
		//   dataLabels: {
		// 	enabled: false,
		//   },
		//   stroke: {
		// 	show: true,
		// 	width: 2,
		// 	colors: ['transparent'],
		//   },
		//   xaxis: {
		// 	categories: $this.page_summary_data['activity_comms']['x-axis'],
		// 	title: {
		// 	  text: '',
		// 	},
		// 	crosshairs: {
		// 	  show: false,
		// 	},
		//   },
		//   yaxis: {
		// 	title: {
		// 	  text: 'Amount',
		// 	},
		// 	labels: {
		// 	  formatter: function (value) {
		// 		let val: string | number = Math.abs(value);
		// 		if (val >= 10 ** 3 && val < 10 ** 6) {
		// 		  val = (val / 1000).toFixed(0) + 'K';
		// 		} else if (val >= 10 ** 6) {
		// 		  val = (val / 1000000).toFixed(0) + 'M';
		// 		} else {
		// 		  val = val;
		// 		}
		// 		return val;
		// 	  },
		// 	},
		//   },
		//   fill: {
		// 	opacity: 1,
		//   },
		//   tooltip: {
		// 	y: {
		// 	  formatter: function (value) {
		// 		let val: string | number = Math.abs(value);
		// 		if (val >= 10 ** 3 && val < 10 ** 6) {
		// 		  val = (val / 1000).toFixed(0) + 'K';
		// 		} else if (val >= 10 ** 6) {
		// 		  val = (val / 1000000).toFixed(0) + 'M';
		// 		} else {
		// 		  val = val;
		// 		}
		// 		return val;
		// 	  },
		// 	},
		//   },
		// };

		// var chart = new ApexCharts(document.querySelector('#communication-channel-activities-graph'), options);
		// chart.render();

		let $this = this;
		let label_colors: any = [];

		for (let index = 0; index < $this.page_summary_data['radar_chart']["x-axis"].length; index++) {
			label_colors.push("#000000");
		}

		var options = {
			colors: $this.page_summary_data['radar_chart']['colors'],
			series: [{
				name: '',
				data: $this.page_summary_data['radar_chart']["y-axis"],
				// data: [10, 20, 30, 10, 40, 66, 11, 33, 22, 77],
			}],
			chart: {
				type: 'radar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
			},
			plotOptions: {
				radar: {
				  size: 140,
				  offsetX: 0,
				  offsetY: 10,
				  polygons: {
					strokeColors: '#858a90',
					strokeWidth: 1,
					connectorColors: '#858a90',
					// fill: {
					// 	colors: ['#f8f8f8', '#fff']
					// }
				  }
				}
			  },
			title: {
				text: ''
			},
			yaxis: {
				// stepSize: 20
			},
			xaxis: {
				categories: $this.page_summary_data['radar_chart']["x-axis"],
				labels: {
					style: {
					//   colors: $this.page_summary_data['radar_chart']['colors']
					  colors: label_colors
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector("#communication-channel-activities-graph"), options);
		chart.render();
	}

	createMonthlyActivityGraph() {
		let $this = this;
		var options = {
		  // colors: ["#D3D3D3", "#55A1EF"],
		//   colors: ['#1B82EC', '#FFA724', '#91C906'],
		  series: $this.page_summary_data['activity_months']['y-axis'],
		  chart: {
			type: 'bar',
			toolbar: {
			  show: false,
			},
			zoom: {
			  enabled: false,
			},
			height: 280,
		  },
		  noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			  color: '#006AFF',
			  fontSize: '24px',
			  fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		  },
		  plotOptions: {
			bar: {
			  horizontal: false,
			  columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('monthly-activities-graph').clientWidth,
				$this.page_summary_data['activity_months']['x-axis'].length,
				30,
			  ),
			  endingShape: 'rounded',
			},
		  },
		  dataLabels: {
			enabled: false,
		  },
		  stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		  },
		  xaxis: {
			categories: $this.page_summary_data['activity_months']['x-axis'],
			title: {
			  text: '',
			},
			crosshairs: {
			  show: false,
			},
		  },
		  yaxis: {
			title: {
			  text: 'Amount',
			},
			labels: {
			  // formatter: function (value) {
				// let val: string | number = Math.abs(value);
				// if (val >= 10 ** 3 && val < 10 ** 6) {
				//   val = (val / 1000).toFixed(0) + 'K';
				// } else if (val >= 10 ** 6) {
				//   val = (val / 1000000).toFixed(0) + 'M';
				// } else {
				//   val = val;
				// }
				// return val;
			  // },
        formatter: (value: number) => {
          return this.commonService.labelFormatter(value);
        }
			},
		  },
		  fill: {
			opacity: 1,
		  },
		  tooltip: {
			y: {
			  // formatter: function (value) {
				// let val: string | number = Math.abs(value);
				// if (val >= 10 ** 3 && val < 10 ** 6) {
				//   val = (val / 1000).toFixed(0) + 'K';
				// } else if (val >= 10 ** 6) {
				//   val = (val / 1000000).toFixed(0) + 'M';
				// } else {
				//   val = val;
				// }
				// return val;
			  // },
        formatter: (value: number) => {
          return this.commonService.labelFormatter(value);
        }
			},
		  },
		};

		var chart = new ApexCharts(document.querySelector('#monthly-activities-graph'), options);
		chart.render();
	}

	source_type: any = '';
  getSourceGraph() {
    let $this = this;
    var options = {
      series: [
        {
          name: '',
          data: $this.page_summary_data['leads_by_source']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        events: {
          dataPointSelection: function (event, chartContext, config) {
            const details = {
              id: $this.page_summary_data['leads_by_source']['x-axis'][
                config.dataPointIndex
              ],
              name: $this.page_summary_data['leads_by_source']['x-axis'][
                config.dataPointIndex
              ],
            };
            $this.source_type =
              $this.source_type == details.id ? '' : details.id;
            $this.current_pagination_page = 1;
            $this.getTableData();
          },
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 280,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('source-graph').clientWidth,
            $this.page_summary_data['leads_by_source']['x-axis'].length,
            20,
          ),
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_summary_data['leads_by_source']['x-axis'],
        title: {
          text: '',
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
      },
      fill: {
        opacity: 1,
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#source-graph'),
      options,
    );
    chart.render();
  }

  age_trigger_name: any = '';
  age_trigger_id: any = '';
  getAgeTriggerGraph() {
    let $this = this;
    var options = {
      // colors: "#D3D3D3",
      series: [
        {
          name: '',
          data: $this.page_summary_data['prospects_by_age']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        events: {
          dataPointSelection: function (event, chartContext, config) {
            const details = {
              id: $this.page_summary_data['prospects_by_age']['labels'][
                config.dataPointIndex
              ],
              name: $this.page_summary_data['prospects_by_age']['x-axis'][
                config.dataPointIndex
              ],
            };
            $this.age_trigger_id =
              $this.age_trigger_id == details.id ? '' : details.id;
            $this.age_trigger_name =
              $this.age_trigger_name == details.name ? '' : details.name;
            $this.current_pagination_page = 1;
            $this.getTableData();
          },
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 280,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('age-triggers-graph').clientWidth,
            $this.page_summary_data['prospects_by_age']['x-axis'].length,
            20,
          ),
          endingShape: 'rounded',
          // dataLabels: {
          //   position: 'bottom'
          // },
        },
      },
      dataLabels: {
        enabled: false,
        textAnchor: 'start',
        style: {
          colors: ['#000000'],
          fontWeight: '200',
        },
        formatter: function (val, opt) {
          return opt.w.globals.labels[opt.dataPointIndex];
        },
        offsetX: 0,
        dropShadow: {
          enabled: false,
        },
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_summary_data['prospects_by_age']['codes'],
        title: {
          // text: 'Age Range'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div style="width:250px; padding:8px">' +
            // '<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Age</b>: ' +
            // $this.page_summary_data['prospects_by_age']['x-axis'][dataPointIndex] +
            // '</p>' +
            '<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
            $this.page_summary_data['prospects_by_age']['legends'][dataPointIndex] +
            '</p>' +
            '<p><b>Value</b>: ' +
            $this.page_summary_data['prospects_by_age']['y-axis'][dataPointIndex] +
            '</p>' +
            '<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description</b>: ' +
            $this.page_summary_data['prospects_by_age']['description'][dataPointIndex] +
            '</p>' +
            '</div>'
          );
        },
        //   fixed: {
        //   enabled: true,
        //   position: "topRight"
        // }
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#age-triggers-graph'),
      options,
    );
    chart.render();
  }

  date_trigger_name: any = '';
	date_trigger_id: any = '';
	getDateTriggerGraph() {
		let $this = this;
		var options = {
		// colors: "#D3D3D3",
		series: [
			{
				name: '',
				data: $this.page_summary_data['prospects_by_date']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['prospects_by_date']['labels'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['prospects_by_date']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.date_trigger_id =
				$this.date_trigger_id == details.id ? '' : details.id;
				$this.date_trigger_name =
				$this.date_trigger_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('date-triggers-graph').clientWidth,
				$this.page_summary_data['prospects_by_date']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['prospects_by_date']['codes'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			// y: {
			//   formatter: function (val) {
			//     return val
			//   }
			// }
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			return (
				'<div style="width:250px; padding:8px">' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
				$this.page_summary_data['prospects_by_date']['legends'][dataPointIndex] +
				'</p>' +
				'<p><b>Value</b>: ' +
				$this.page_summary_data['prospects_by_date']['y-axis'][dataPointIndex] +
				'</p>' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description</b>: ' +
				$this.page_summary_data['prospects_by_date']['description'][dataPointIndex] +
				'</p>' +
				'</div>'
			);
			},
			//  fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#date-triggers-graph'),
		options,
		);
		chart.render();
	}

	data_trigger_name: any = '';
	data_trigger_id: any = '';
	getDataTriggerGraph() {
		let $this = this;
		var options = {
		// colors: "#D3D3D3",
		series: [
			{
			name: '',
			data: $this.page_summary_data['prospects_by_data']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['prospects_by_data']['labels'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['prospects_by_data']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.data_trigger_id =
				$this.data_trigger_id == details.id ? '' : details.id;
				$this.data_trigger_name =
				$this.data_trigger_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('data-triggers-graph').clientWidth,
				$this.page_summary_data['prospects_by_data']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['prospects_by_data']['codes'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			// y: {
			//   formatter: function (val) {
			//     return val
			//   }
			// }
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			return (
				'<div style="width:250px; padding:8px">' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
				$this.page_summary_data['prospects_by_data']['legends'][dataPointIndex] +
				'</p>' +
				'<p><b>Value</b>: ' +
				$this.page_summary_data['prospects_by_data']['y-axis'][dataPointIndex] +
				'</p>' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description</b>: ' +
				$this.page_summary_data['prospects_by_data']['description'][dataPointIndex] +
				'</p>' +
				'</div>'
			);
			},
			//  fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#data-triggers-graph'),
		options,
		);
		chart.render();
	}

  ai_trigger_name: any = '';
	ai_trigger_id: any = '';
	getAITriggerGraph() {
		let $this = this;
		var options = {
		// colors: "#D3D3D3",
		series: [
			{
			name: '',
			data: $this.page_summary_data['prospects_by_ai']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_summary_data['prospects_by_ai']['labels'][
					config.dataPointIndex
				],
				name: $this.page_summary_data['prospects_by_ai']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.ai_trigger_id =
				$this.ai_trigger_id == details.id ? '' : details.id;
				$this.ai_trigger_name =
				$this.ai_trigger_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getTableData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 280,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('ai-triggers-graph').clientWidth,
				$this.page_summary_data['prospects_by_ai']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_summary_data['prospects_by_ai']['x-axis'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
			show: false,
			},
		},
		yaxis: {
			labels: {
			show: false,
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			// y: {
			//   formatter: function (val) {
			//     return val
			//   }
			// }
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			return (
				'<div style="width:250px; padding:8px">' +
				'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
				$this.page_summary_data['prospects_by_ai']['x-axis'][dataPointIndex] +
				'</p>' +
				'<p><b>Value</b>: ' +
				$this.page_summary_data['prospects_by_ai']['y-axis'][dataPointIndex] +
				'</p>' +
				'</div>'
			);
			},
			//  fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#ai-triggers-graph'),
		options,
		);
		chart.render();
	}

  propensity_score_name: any = '';
  propensity_score_id: any = '';
  getPropensityScoreGraph() {
    let $this = this;
    var options = {
      // colors: "#D3D3D3",
      series: [
        {
          name: '',
          data: $this.page_summary_data['prospects_by_propensity_score']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        events: {
          dataPointSelection: function (event, chartContext, config) {
            const details = {
              id: $this.page_summary_data["prospects_by_propensity_score"]['x-axis'][config.dataPointIndex],
              name: $this.page_summary_data['prospects_by_propensity_score']['x-axis'][
                config.dataPointIndex
              ],
            };
            $this.propensity_score_id = $this.propensity_score_id == details.id ? "" : details.id;
            $this.propensity_score_name =
              $this.propensity_score_name == details.name ? '' : details.name;
            $this.current_pagination_page = 1;
            $this.getTableData();
          },
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 280,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('propensity-score-graph').clientWidth,
            $this.page_summary_data['prospects_by_propensity_score']['x-axis'].length,
            20,
          ),
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_summary_data['prospects_by_propensity_score']['x-axis'],
        title: {
          // text: 'Value'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
      },
      fill: {
        opacity: 1,
      },
      // tooltip: {
      //   custom: function({series, seriesIndex, dataPointIndex, w}) {
      //     var data = $this.page_summary_data["prospects_by_propensity_score"]["y-axis"][dataPointIndex];

      //     return 'Count :' + data ;
      //   }
      // }
    };

    var chart = new ApexCharts(
      document.querySelector('#propensity-score-graph'),
      options,
    );
    chart.render();
  }

  updateFlag = false;
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = 'mapChart';
  chartOptions: Highcharts.Options = {
    chart: {
      map: USA,
    },
    exporting: {
      enabled: false,
    },
    title: {
      text: '',
    },
    subtitle: {
      text: '<a href="http://code.highcharts.com/mapdata/countries/us/us-all.js"></a>',
    },
    mapNavigation: {
      enabled: true,
      buttonOptions: {
        alignTo: 'spacingBox',
      },
    },
    legend: {
      enabled: true,
    },
    colorAxis: {
      min: 0,
    },
    series: [
      {
        type: 'map',
        states: {
          hover: {
            color: '#BADA55',
          },
        },
        dataLabels: {
          enabled: true,
          format: '{point.value}',
        },
        allAreas: false,
        data: [],
      },
    ],
  };
  getRegionGraph() {
    let $this = this;
    $this.chartOptions.series[0] = {
      type: 'map',
      name: '',
      states: {
        hover: {
          color: '#BADA55',
        },
      },
      dataLabels: {
        enabled: true,
        format: '{point.properties.postal-code}',
      },
      allAreas: false,
      data: $this.page_summary_data['prospects_by_region'],
    };
    this.updateFlag = true;
  }

	search_key: any = '';

	current_pagination_page = 1;
	total_pagination_records = 0;
	pagination_records_limit: any = 10;

	selected_alphabet = '';
	alphabets_array = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',];
	show_search: boolean = false;
	table_columns: any = [];
	table_data: any = [];
	selected_table_data: any = [];
	table_data_loaded: boolean = false;
	show_toggle_columns: boolean = false;
	getTableData() {

		this.show_activity_view = null;
		this.show_prospecttrustedcontact = null;

		this.selected_client = {
			id: ""
		};
		this.table_data_loaded = false;

		// let route: any = "/client?records_per_page=" + this.pagination_records_limit + "&search=" + this.search_key + "&alphabet=" + this.selected_alphabet + "&page=" + this.current_pagination_page + "&advisor=" + this.user_details.id + "&clients_by_age_trigger=" + this.age_trigger_id + "&clients_by_date_trigger=" + this.date_trigger_id + "&clients_by_data_trigger=" + this.data_trigger_id + "&clients_by_csvalue=" + this.client_value_id + "&clients_by_csdays=" + this.client_closure_id + "&duration=" + this.selected_opportunity_period + "&stage=Follow Up";

		// let type: any = "";
		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {
		// 		type = "Total Opportunities"
		// 	} else {
		// 		type = this.selected_sale_type;
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	type = "Up-Sell Opportunities";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	type = "Cross-Sell Opportunities";
		// }

		let route: any = "/prospectopportunitytableupdated/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + this.current_pagination_page + "/" + "?records_per_page=" + this.pagination_records_limit + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&prospects_by_age_trigger=" + this.age_trigger_id + "&prospects_by_data_trigger=" + this.data_trigger_id +"&prospects_by_date_trigger=" + this.date_trigger_id +"&prospects_by_ai_trigger=" + this.ai_trigger_id +"&source=" + this.source_type + "&propensity_score=" + this.propensity_score_id + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

    if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {

       "/magiclienttableupdated/" + this.selected_top_percentage + "/" + this.selected_high_value_leads + "/" + this.selected_analysis_value + "/" + this.type + "/" + this.current_pagination_page + "/" + "?records_per_page=" + this.pagination_records_limit + "&search=" + this.search_key + "&business_plan_id=" + this.business_plan + "&prospects_by_age_trigger=" + this.age_trigger_id + "&prospects_by_data_trigger=" + this.data_trigger_id +"&prospects_by_date_trigger=" + this.date_trigger_id +"&prospects_by_ai_trigger=" + this.ai_trigger_id +"&source=" + this.source_type + "&propensity_score=" + this.propensity_score_id + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

    }

		if (this.type == "New Prospects") {
			route = route + "&prospect_type=New Prospect";
		} else {
			route = route + "&prospect_type=New";
		}

		if (this.opp_year_id != '') {
			route = route + "&yearly_filter=" + this.opp_year_id;
		} else {
			route = route + "&opp_year=" + this.selected_opportunity_period;
		}

		// if (this.type == "Total Opportunities") {
		// 	if (this.selected_sale_type == "all") {

		// 	} else if (this.selected_sale_type == "Up-Sell Opportunities") {
		// 		route = route + "&clients_by_upsell=true";
		// 	} else if (this.selected_sale_type == "Cross-Sell Opportunities") {
		// 		route = route + "&clients_by_crosssell=true";
		// 	}
		// } else if (this.type == "Up-Sell Opportunities") {
		// 	route = route + "&clients_by_upsell=true";
		// } else if (this.type == "Cross-Sell Opportunities") {
		// 	route = route + "&clients_by_crosssell=true";
		// }

		this.commonService.getData(route).subscribe(
			(res: any) => {
        this.table_columns = res['columns'];
        // for (let index = 0; index < this.table_columns.length; index++) {
        if (this.table_columns.length > 0) {
          for (let index = 0; index < 9; index++) {
            this.table_columns[index].checked = true;
          }
        }
				// this.table_data = res['results']['data'];
				this.table_data = res['results'];
				this.current_pagination_page = res.page_number;
				this.total_pagination_records = res.total_no_of_records;
				this.table_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		  );
	}

	pageChanged(event) {

		this.show_activity_view = null;
		this.show_prospecttrustedcontact = null;

		this.current_pagination_page = event;
		this.pagination_records_limit = this.pagination_records_limit;
		this.getTableData();
	}

	getTableKey(data, column) {
		const key = column['key'];
		return data[key];
	}

	@ViewChild('clientDataModal') clientDataModal: TemplateRef<any>;
	private clientDataModalRef: MatDialogRef<TemplateRef<any>>;

	selected_modal_client: any;
	selected_modal_client_loader: boolean = false;;
	openClientDataModal(data) {
		this.selected_modal_client_loader = true;
		this.selected_modal_client = JSON.parse(JSON.stringify(data));


		this.clientDataModalRef = this.dialog.open(this.clientDataModal, { disableClose: true });
		this.clientDataModalRef.afterClosed().subscribe((result) => {
			this.closeClientDataModal();
		});

		// this.commonService.getData('/customerdetails/?id=' + this.selected_modal_client.id).subscribe(
		this.commonService.getData('/prospectdetails/?id=' + this.selected_modal_client.id).subscribe(
			(res: any) => {
				this.selected_modal_client = res["data"];
				this.selected_modal_client_loader = false;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	closeClientDataModal() {
		this.selected_modal_client = {};
		this.clientDataModalRef.close();
		this.selected_modal_client_loader = false;
	}

	selected_client:any = {
		id: ""
	};
	selected_client_summary:any = {};
	selected_client_summary_loader:boolean = false;
	selectClient(data) {
		this.selected_client_summary_loader = true;
		this.selected_client = JSON.parse(JSON.stringify(data));
		this.selected_client_summary = {};
		this.commonService.getData("/clientfollowupdetails?id=" + this.selected_client.id).subscribe(
			(res: any) => {
				this.selected_client_summary = res["client_details"];
				this.selected_client_summary_loader = false;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.selected_client_summary_loader = false;
			},
		);
	}

	deSelectClient() {
		this.selected_client = {
			id: ""
		};
	}

	show_opporunity_description: boolean = false;
	show_close_deal_description: boolean = false;
	show_preferred_channel_description: boolean = false;


  show_activity_view: number = null;
  toggleActivityView(value) {
    if (this.show_activity_view == value) {
      this.show_activity_view = null;
    } else {
      this.show_activity_view = value;
    }
  }

  dataChanged(event) {
	this.show_activity_view = null;
    this.getTableData();
    this.changeStepper();
  }

  @Output() stepperChange = new EventEmitter<any>();
  changeStepper() {
    // const data = {
    //   step: 2,
    // };
    // this.stepperChange.emit(data);
	this.stepperChange.emit(this.stepper_stage);
  }

  	opportunity_client: any;
  	@ViewChild('addOpportunityModal') addOpportunityModal: TemplateRef<any>;
	private addOpportunityModalRef: MatDialogRef<TemplateRef<any>>;
	openAddOpportunityModal(data) {
		this.opportunity_client = JSON.parse(JSON.stringify(data));
		this.addOpportunityModalRef = this.dialog.open(
			this.addOpportunityModal, { disableClose: true }
		);
		this.addOpportunityModalRef.afterClosed().subscribe((result) => {
			this.closeAddOpportunityModal();
		});
	}

	closeAddOpportunityModal() {
		this.addOpportunityModalRef.close();
		this.opportunity_client = {};
	}

	addOpportunity() {
		const payload = {
			id: this.opportunity_client.id
		};
		this.commonService.postData("/converttoopportunity/", payload).subscribe(
			(res: any) => {
				this.commonService.showToast('success', 'Client Added to Upside Opportunities Successfully.');
				this.getPageSummary();
				this.closeAddOpportunityModal();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	// New Lead Modal

	@ViewChild('clientOperationsModal') clientOperationsModal: TemplateRef<any>;
	private clientOperationsModalRef: MatDialogRef<TemplateRef<any>>;

	clientOperationIndex: any = null;
	clientOperationType: any = '';
	clientOperationsProgress: any = 1;
	client_data: any = {};
	client_error: boolean = false;
	product_list: any = [];
	openClientOperationModal(type, index, data) {
	  this.clientOperationIndex = index;
	  this.clientOperationType = type;
	  this.client_data = JSON.parse(JSON.stringify(data));
	  if (this.clientOperationType == 'Add') {
		// this.client_data.status = "Active";
	  } else {
		this.client_data.birth_date = this.datePipe.transform(
		  this.client_data.birth_date,
		  'MM-dd-yyyy',
		);
		this.getDataTypeValues(this.client_data.source_type_id);
	  }
	  this.clientOperationsModalRef = this.dialog.open(
		this.clientOperationsModal, { disableClose: true }
	  );
	  this.clientOperationsModalRef.afterClosed().subscribe((result) => {
		this.closeClientOperationModal();
	  });
	}

	closeClientOperationModal() {
	  this.clientOperationIndex = null;
	  this.clientOperationType = '';
	  this.clientOperationsProgress = 1;
	  this.client_data = {};
	  this.clientOperationsModalRef.close();
	}

	represent_years: any = [];
	calculateYears() {
	  let current_year = new Date().getFullYear();
	  const limit = 70;
	  for (let index = 0; index < limit; index++) {
		this.represent_years.push(current_year);
		current_year = current_year - 1;
	  }
	}

	validateClientForm() {
	  let update = false;
	  this.client_error = false;
	  if (this.clientOperationsProgress == 1) {
		if (
		  this.client_data.prospect_id != '' &&
		  this.client_data.prospect_id != null &&
		  this.client_data.first_name != '' &&
		  this.client_data.first_name != null &&
		  this.client_data.email != '' &&
		  this.client_data.email != null &&
		  // (this.client_data.telephone_number != '' && this.client_data.telephone_number != null) &&
		  this.client_data.birth_date != '' &&
		  this.client_data.birth_date != null &&
		  // (this.client_data.status_id != '' && this.client_data.status_id != null) &&
		  this.client_data.state_id != '' &&
		  this.client_data.state_id != null &&
		  this.client_data.region_id != '' &&
		  this.client_data.region_id != null
		) {
		  if (this.validEmail(this.client_data.email)) {
			// if (this.validatePhoneNumber(this.client_data.telephone_number)) {
			//   this.client_error = false;
			//   update = true;
			// } else {
			//   this.client_error = true;
			// }
			this.client_error = false;
			update = true;
		  } else {
			this.client_error = true;
		  }
		} else {
		  this.client_error = true;
		}
	  } else if (this.clientOperationsProgress == 2) {
		if (
		  this.client_data.individual_income_in_dollars_actual != '' &&
		  this.client_data.individual_income_in_dollars_actual != null
		) {
		  this.client_error = false;
		  update = true;
		} else {
		  this.client_error = true;
		}
	  } else if (this.clientOperationsProgress == 3) {
		if (
		  this.client_data.source_type_id != '' &&
		  this.client_data.source_type_id &&
		  this.client_data.source_type_id != null &&
		  // (this.data_type_values_list.length > 0 && this.client_data.source_id && this.client_data.source_id != '' && this.client_data.source_id != null) &&
		  // (this.client_data.type != '' && this.client_data.type != null) &&
		  this.client_data.business_plan_id &&
		  this.client_data.business_plan_id != '' &&
		  this.client_data.business_plan_id != null &&
		  this.client_data.net_worth_actual != '' &&
		  this.client_data.net_worth_actual != null &&
		  this.client_data.client_wallet_share_from_lpl_actual != '' &&
		  this.client_data.client_wallet_share_from_lpl_actual != null &&
		  this.client_data.client_net_worth_from_lpl_actual != '' &&
		  this.client_data.client_net_worth_from_lpl_actual != null
		) {
		  if (this.data_type_values_list.length == 0) {
			this.client_error = false;
			update = true;
		  } else {
			if (
			  this.client_data.source_id &&
			  this.client_data.source_id != '' &&
			  this.client_data.source_id != null
			) {
			  this.client_error = false;
			  update = true;
			} else {
			  this.client_error = true;
			}
		  }
		} else {
		  this.client_error = true;
		}
	  } else {
		update = true;
	  }

	  if (update == true) {
		if (this.clientOperationsProgress == 3) {
		  this.saveClientDetails();
		} else {
		  this.clientOperationsProgress = this.clientOperationsProgress + 1;
		}
	  }
	}

	validatePhoneNumber(number) {
	  const regex = /^[\+][(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/gm;
	  if (number == null || number == '') {
		return false;
	  }

	  if (regex.test(number) == true) {
		return true;
	  } else {
		return false;
	  }
	}

	saveClientDetails() {
	  this.client_data.birth_date = this.datePipe.transform(
		this.client_data.birth_date,
		'yyyy-MM-dd',
	  );
	  // this.client_data.household_income_in_dollars =
  //       this.client_data.household_income_in_dollars_actual;
  //     this.client_data.home_equity_available_for_mortgage_in_dollars =
  //       this.client_data.home_equity_available_for_mortgage_in_dollars_actual;
  //     this.client_data.market_value_of_home_in_dollars =
  //       this.client_data.market_value_of_home_in_dollars_actual;
  //     this.client_data.net_worth = this.client_data.net_worth_actual;

  if (this.client_data.net_worth_actual) {
	this.client_data.net_worth = this.client_data.net_worth_actual;

  }
  if (this.client_data.client_wallet_share_from_lpl_actual) {
    this.client_data.client_wallet_share_from_lpl = this.client_data.client_wallet_share_from_lpl_actual;
  }
  if (this.client_data.client_net_worth_from_lpl_actual) {
    this.client_data.client_net_worth_from_lpl = this.client_data.client_net_worth_from_lpl_actual;
  }

  if (this.client_data.household_income_in_dollars_actual) {
	this.client_data.household_income_in_dollars = this.client_data.household_income_in_dollars_actual;
  }

  if (this.client_data.market_value_of_home_in_dollars_actual) {
	this.client_data.market_value_of_home_in_dollars = this.client_data.market_value_of_home_in_dollars_actual;
  }

  if (this.client_data.home_equity_available_for_mortgage_in_dollars_actual) {
	this.client_data.home_equity_available_for_mortgage_in_dollars = this.client_data.home_equity_available_for_mortgage_in_dollars_actual;
  }

  if (this.client_data.individual_income_in_dollars_actual) {
	this.client_data.individual_income_in_dollars = this.client_data.individual_income_in_dollars_actual;
  }

  if (this.client_data.total_networth_actual) {
	this.client_data.total_networth = this.client_data.total_networth_actual;
  }

  if (this.client_data.money_managed_revenue_actual) {
	this.client_data.money_managed_revenue = this.client_data.money_managed_revenue_actual;
  }

  if (this.client_data.other_investment_actual) {
	this.client_data.other_investment = this.client_data.other_investment_actual;
  }

  if (this.client_data.current_assests_actual) {
	this.client_data.current_assests = this.client_data.current_assests_actual;
  }

  if (this.client_data.expenses_actual) {
	this.client_data.expenses = this.client_data.expenses_actual;
  }

  if (this.client_data.liabilities_actual) {
	this.client_data.liabilities = this.client_data.liabilities_actual;
  }
	  if (this.clientOperationType == 'Add') {
		this.commonService.postData('/prospect/', this.client_data).subscribe(
		  (res: any) => {
			this.client_error = false;
			// this.cancelProductDetails();
			this.closeClientOperationModal();
			this.getTableData();
			this.commonService.showToast(
			  'success',
			  'Lead has been added successfully.',
			);
		  },
		  (err) => {
			this.commonService.showToast('error', err.error);
		  },
		);
	  } else {
		this.commonService
		  .updateData('/prospect/' + this.client_data.id + '/', this.client_data)
		  .subscribe(
			(res: any) => {
			  this.client_error = false;
			  // this.cancelProductDetails();
			  this.closeClientOperationModal();
			  this.getTableData();
			  this.commonService.showToast(
				'success',
				'Lead has been updated successfully.',
			  );
			},
			(err) => {
			  this.commonService.showToast('error', err.error);
			},
		  );
	  }
	}

	numberOnly(event): boolean {
	  const charCode = event.which ? event.which : event.keyCode;
	  if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
		return false;
	  }
	}

	validEmail(email) {
	  if (
		email != '' &&
		/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
	  ) {
		return true;
	  } else {
		return false;
	  }
	}

	data_type_list: any = [];
	getDataTypeList() {
	  this.commonService.getData('/datatype?no_page=true/').subscribe(
		(res: any) => {
		  this.data_type_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	data_type_values_list: any = [];
	getDataTypeValues(value) {
	  // this.commonService
	  //   .getData('/datatypevalue?data_type=' + value + '&no_page=true/')
	  //   .subscribe(
	  //     (res: any) => {
	  //       this.data_type_values_list = res;
	  //     },
	  //     (err) => {
	  //       this.commonService.showToast('error', err.error);
	  //     },
	  //   );
	  if (value == 4) {

	  } else if (value == 5) {
		this.commonService.getData('/datatypevalue?data_type=' + value + '&no_page=true/',).subscribe(
		  (res: any) => {
			this.data_type_values_list = res;
		  },
		  (err) => {
			this.commonService.showToast('error', err.error);
		  }
		);
	  } else if (value == 6) {
		this.commonService.getData('/financialinstitution?no_page=true/',).subscribe(
		  (res: any) => {
			this.data_type_values_list = res;
		  },
		  (err) => {
			this.commonService.showToast('error', err.error);
		  }
		);
	  } else {
		this.commonService.getData('/datatypevalue?data_type=' + value + '&no_page=true/',).subscribe(
		  (res: any) => {
			this.data_type_values_list = res;
		  },
		  (err) => {
			this.commonService.showToast('error', err.error);
		  }
		);
	  }
	}

	product_group_list: any = [];
	getProductGroups() {
	  this.commonService.getData('/productGroup?no_page=true/').subscribe(
		(res: any) => {
		  this.product_group_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	genders_list: any = [];
	getGenders() {
	  this.commonService.getData('/gender?no_page=true/').subscribe(
		(res: any) => {
		  this.genders_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	advisor_status_list: any = [];
	getAdvisorStatus() {
	  this.commonService.getData('/advisorStatus?no_page=true/').subscribe(
		(res: any) => {
		  this.advisor_status_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	states_list: any = [];
	getStates() {
	  this.commonService.getData('/state?no_page=true/').subscribe(
		(res: any) => {
		  this.states_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	region_list: any = [];
	getRegion() {
	  const financial_institution = this.user_details.financial_institution;
	  this.commonService.getData('/region?no_page=true&financial_institution=' + financial_institution).subscribe(
		(res: any) => {
		  this.region_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	status_list: any = [];
	getStatus() {
	  this.commonService.getData('/clientStatus?no_page=true/').subscribe(
		(res: any) => {
		  this.status_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	advisor_type_list: any = [];
	getAdvisorTypes() {
	  this.commonService.getData('/advisorType?no_page=true/').subscribe(
		(res: any) => {
		  this.advisor_type_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	licenses_list: any = [];
	getLicenses() {
	  this.commonService.getData('/licenses?no_page=true/').subscribe(
		(res: any) => {
		  this.licenses_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	employment_type_list: any = [];
	getEmploymentTypes() {
	  this.commonService.getData('/employmentType?no_page=true/').subscribe(
		(res: any) => {
		  this.employment_type_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	company_registration_type_list: any = [];
	getCompanyRegistrationTypes() {
	  this.commonService.getData('/registrationType?no_page=true/').subscribe(
		(res: any) => {
		  this.company_registration_type_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	business_plan_list: any = [];
	getBusinessPlan() {
		  const financial_institution = this.user_details.financial_institution;
	  this.commonService.getData('/businessPlan?no_page=true&financial_institution=' + financial_institution).subscribe(
		(res: any) => {
		  this.business_plan_list = res;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}


	is_selected: boolean = false;
	selectAll(event) {
		if (event.checked == true) {
			this.selected_table_data = JSON.parse(JSON.stringify(this.table_data));
			this.is_selected = true;
		} else {
			this.selected_table_data = [];
			this.is_selected = false;
		}
	}

	checkIndividualSelection(data) {
		const index = this.selected_table_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			return true;
		} else {
			return false;
		}
	}

	selectIndividual(event, data) {
		const index = this.selected_table_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			if (event.checked == true) {
				this.selected_table_data.splice(index, 0, data);
			} else {
				this.selected_table_data.splice(index, 1);
			}
		} else {
			this.selected_table_data.splice(index, 0, data);
		}

		if (this.table_data.length == this.selected_table_data.length) {
			this.is_selected = true;
		} else {
			this.is_selected = false;
		}
	}

	move_record_error: boolean = false;
  	@ViewChild('moveRecordModal') moveRecordModal: TemplateRef<any>;
	private moveRecordModalRef: MatDialogRef<TemplateRef<any>>;
	openMoveRecordModal() {
		if (this.selected_table_data.length > 0) {
			this.moveRecordModalRef = this.dialog.open(this.moveRecordModal, { disableClose: true });
			this.moveRecordModalRef.afterClosed().subscribe((result) => {
				this.closeMoveRecordModal();
			});
			this.move_record_error = false;
		} else {
			this.move_record_error = true;
		}
	}

	closeMoveRecordModal() {
		this.moveRecordModalRef.close();
		this.move_record_error = false;
		this.move_record_stage = "";
		this.move_record_stage_error = false;
	}

	stages_data: any = [];
	getStages() {
		let type: any = "";
		if (this.type == "Upside Opportunities") {
			type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			type = "new";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			type = "members";
		} else if (this.type == "Non Customers") {
			type = "non_members";
		}

		this.commonService.getData('/stage?no_page=true&financial_institution=' + this.user_details.financial_institution + '&current_stage=' + this.stepper_stage.id + "&type=" + type + "&business_area=" + this.user_details.role.business_area[0]).subscribe(
			(res: any) => {
				this.stages_data = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	move_record_stage: any = "";
	move_record_stage_error: boolean = false;
	move_record_stage_activity_status: boolean = false;
	changeClientStage() {
		if (this.move_record_stage != "" && this.move_record_stage != null) {
			this.move_record_stage_error = false;
		} else {
			this.move_record_stage_error = true;
		}

		let payload: any = {
			current_stage: this.stepper_stage.id,
			target_stage: this.move_record_stage,
			client_list: [],
			not_required: this.move_record_stage_activity_status,
			type: ""
		};

		if (this.type == "Upside Opportunities") {
			payload.type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			payload.type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			payload.type = "new";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			payload.type = "members";
		} else if (this.type == "Non Customers") {
			payload.type = "non_members";
		}

		for (let index = 0; index < this.selected_table_data.length; index++) {
			payload.client_list.push(this.selected_table_data[index].id);
		}

		if (this.move_record_stage_error == false) {
			this.commonService.postData("/movestage/", payload).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Stage Changed Successfully.');
					this.closeMoveRecordModal();
					this.selected_table_data = [];
					this.is_selected = false;
					this.changeStepper();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}

	leads_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Opportunity",
					value: "New opportunity is a crucial metric that helps identify the most promising targets for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: AI rank and predicted wallet share"
				},
				{
					name: "AI Rank",
					value: "AI model comes into play to calculate the probability of successful sales for each identified target. The AI model considers various target-specific attributes, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of closing a deal."
				},
				{
					name: "Predicted Wallet Share",
					value: "This valuable metric is used to forecast the potential growth in the prospect's wallet share. It is calculated by utilizing the insights provided by the predicted opportunity along with the net worth of the prospect. This information aids the company in making data-driven decisions regarding resource allocation, targeted marketing strategies, and personalized offerings to enhance the prospect's overall engagement and satisfaction."
				}
			]
		},
	];

	show_user_profile: boolean = false;
    user_profile_data: any;
    showUserProfile(data) {
      this.user_profile_data = JSON.parse(JSON.stringify(data));
      this.show_user_profile = true;
    }

    profileClosed(event) {
      this.user_profile_data = {};
      this.show_user_profile = false;
    }

	rule_based_tooltip_section: any = [
		{
			name: "Rules-Based Triggers have been developed in collaboration with financial advisors, wealth management experts, and industry thought leaders, drawing on the collective experience of these professionals over the past 30 to 40 years."
		},
		{
			name: "This knowledge encompasses how financial advisors and institutions have historically identified new opportunities, cross-selling potentials, and clients who may be at risk of departing. These triggers are adaptable and can be customized to align with the specific internal regulations of any organization."
		}
	];

	ai_based_tooltip_section: any = [
		{
			name: "AI triggers have been pinpointed through the analysis of three specific scenarios as outlined below:",
			sub_sections: [
				{
					name: "",
					value: "Shifts in customer habits, as well as market and geographical conditions, have been monitored over the last 3 to 5 years. This analysis has consistently revealed certain opportunities or risks."
				},
				{
					name: "",
					value: "The detection of certain anomalies that lack substantial data backing. AI will monitor these closely to determine which are likely to become more regular occurrences.The detection of certain anomalies that lack substantial data backing. AI will monitor these closely to determine which are likely to become more regular occurrences."
				},
				{
					name: "",
					value: "A series of potential opportunities and risks have been identified by AI. Although they are not frequently occurring at present, they are forecasted to happen in the future."
				},
			]
		},
	];

	opp_breakdown_id: any = "";
	opp_breakdown_name: any = "";

	rules_breakdown_id: any =  "";
	rules_breakdown_name: any =  "";

	ai_breakdown_id: any =  "";
	ai_breakdown_name: any =  "";

	common_breakdown_id: any =  "";
	common_breakdown_name: any =  "";
	analysisChanged(data) {
		if (data.type == "Opportunities") {
			this.opp_breakdown_id = data.id;
			this.opp_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "Rule Based Triggers") {
			this.rules_breakdown_id = data.id;
			this.rules_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "AI Triggers") {
			this.ai_breakdown_id = data.id;
			this.ai_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "Common Triggers") {
			this.common_breakdown_id = data.id;
			this.common_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		}
	}

	@ViewChild('syncActivitiesModal') syncActivitiesModal: TemplateRef<any>;
	private syncActivitiesModalRef: MatDialogRef<TemplateRef<any>>;
	openSyncActivitiesModal() {
		this.syncActivitiesModalRef = this.dialog.open(
			this.syncActivitiesModal, { disableClose: true }
		);
		this.syncActivitiesModalRef.afterClosed().subscribe((result) => {
			this.closeSyncActivitiesModal();
		});
	}

	closeSyncActivitiesModal() {
		this.syncActivitiesModalRef.close();
	}

	salesforce_sync_loader: boolean = false;
	salesforceSync(data) {
		this.salesforce_sync_loader = true;
		this.openSyncActivitiesModal();
		let route: any = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Prospect&opp_type=New";
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.salesforce_sync_loader = false;
				this.commonService.showToast('success', 'Data Synced Successfully.');
				this.closeSyncActivitiesModal();
			},
			(err) => {
				this.salesforce_sync_loader = false;
				this.commonService.showToast('error', err.error);
			},
		);
	}


  // Trusted Contact
  prospecttrustedcontact_details: any = {};
  prospecttrustedcontact_details_operation: boolean = false;
  prospecttrustedcontact_details_operation_type: any = 'Add';
  addProspectTrustedContact(data, type) {
    this.prospecttrustedcontact_details = JSON.parse(JSON.stringify(data));
    this.prospecttrustedcontact_details_operation_type = type;
    this.prospecttrustedcontact_details_operation = true;
  }

  cancelProspectTrustedContactDetails() {
    this.prospecttrustedcontact_details = {};
    this.prospecttrustedcontact_details_operation = false;
  }

  addProspectTrustedContactDetails() {
    if (
      this.prospecttrustedcontact_details.first_name != '' &&
      this.prospecttrustedcontact_details.first_name != null &&
      this.prospecttrustedcontact_details.relationship_type != '' &&
      this.prospecttrustedcontact_details.relationship_type != null
    ) {
      this.client_error = false;
      if (this.prospecttrustedcontact_details_operation_type == 'Add') {
        if (!this.client_data.trusted_contact) {
          this.client_data.trusted_contact = [];
        }
        this.client_data.trusted_contact.push(this.prospecttrustedcontact_details);
        this.client_error = false;
        this.cancelProspectTrustedContactDetails();
      } else {
        const index = this.client_data.trusted_contact.findIndex(
          (x) => x.id == this.prospecttrustedcontact_details.id,
        );
        this.client_data.trusted_contact.splice(
          index,
          1,
          this.prospecttrustedcontact_details,
        );
        this.client_error = false;
        this.cancelProspectTrustedContactDetails();
      }
    } else {
      this.client_error = true;
    }
  }

  @ViewChild('deleteProspectTrustedContactModal') deleteProspectTrustedContactModal: TemplateRef<any>;
  private deleteProspectTrustedContactModalRef: MatDialogRef<TemplateRef<any>>;
  deleteProspectTrustedContact(data) {
    this.prospecttrustedcontact_details = JSON.parse(JSON.stringify(data));
    this.deleteProspectTrustedContactModalRef = this.dialog.open(
      this.deleteProspectTrustedContactModal, { disableClose: true }
    );
    this.deleteProspectTrustedContactModalRef.afterClosed().subscribe((result) => {
      this.closeDeleteProspectTrustedContact();
    });
  }

  closeDeleteProspectTrustedContact() {
    this.prospecttrustedcontact_details = {};
    this.deleteProspectTrustedContactModalRef.close();
  }

  deleteTrustedContactDetails() {
    const index = this.client_data.trusted_contact.findIndex(
      (x) => x.id == this.prospecttrustedcontact_details.id,
    );
    this.client_data.trusted_contact.splice(index, 1);
    this.closeDeleteProspectTrustedContact();
  }

  show_prospecttrustedcontact: number = null;
  toggleProspectTrustedContactView(value) {
    if (this.show_prospecttrustedcontact == value) {
      this.show_prospecttrustedcontact = null;
    } else {
      this.show_prospecttrustedcontact = value;
    }
  }

  prospecttrustedcontact_data: any = {
    first_name: "",
    last_name: "",
    email: "",
    birth_date: "",
    gender: "",
    gender_name: "",
    relationship_type: "",
    relationship_type_name: "",
    telephone_number: "",
  };
  prospecttrustedcontact_data_errors: any = {
    first_name: false,
    last_name: false,
    email: false,
    birth_date: false,
    gender: false,
    gender_name: false,
    relationship_type: false,
    relationship_type_name: false,
    telephone_number: false,
  };
  prospecttrustedcontact_operation_type: any = "Add";

  resetProspectTrustedContactData() {
    this.prospecttrustedcontact_data = {
      first_name: "",
      last_name: "",
      email: "",
      birth_date: "",
      gender: "",
      gender_name: "",
      relationship_type: "",
      relationship_type_name: "",
      telephone_number: "",
    };
    this.prospecttrustedcontact_data_errors = {
      first_name: false,
      last_name: false,
      email: false,
      birth_date: false,
      gender: false,
      gender_name: false,
      relationship_type: false,
      relationship_type_name: false,
      telephone_number: false,
    };
    this.prospecttrustedcontact_operation_type = "Add";
  }

  @ViewChild('prospecttrustedcontactOperationModal') prospecttrustedcontactOperationModal: TemplateRef<any>;
  private prospecttrustedcontactOperationModalRef: MatDialogRef<TemplateRef<any>>;
  openProspectTrustedContactOperationModal(data, type) {
    this.prospecttrustedcontact_data = JSON.parse(JSON.stringify(data));
    this.prospecttrustedcontact_operation_type = type;

    if (this.prospecttrustedcontact_operation_type == "Edit") {
      this.prospecttrustedcontact_data.birth_date = this.datePipe.transform(this.prospecttrustedcontact_data.birth_date, 'MM-dd-yyyy');
    }

    this.prospecttrustedcontactOperationModalRef = this.dialog.open(this.prospecttrustedcontactOperationModal, { disableClose: true });
    this.prospecttrustedcontactOperationModalRef.afterClosed().subscribe((result) => {
      this.closeProspectTrustedContactOperationModal();
    });
  }

  closeProspectTrustedContactOperationModal() {
    this.resetProspectTrustedContactData();
    this.prospecttrustedcontactOperationModalRef.close();
  }

  saveProspectTrustedContactData() {

    if (
      this.prospecttrustedcontact_data.first_name != "" &&
      this.prospecttrustedcontact_data.first_name != null
    ) {
      this.prospecttrustedcontact_data_errors.first_name = false;
    } else {
      this.prospecttrustedcontact_data_errors.first_name = true;
    }

    if (
      this.prospecttrustedcontact_data.last_name != "" &&
      this.prospecttrustedcontact_data.last_name != null
    ) {
      this.prospecttrustedcontact_data_errors.last_name = false;
    } else {
      this.prospecttrustedcontact_data_errors.last_name = true;
    }

    if (
      this.prospecttrustedcontact_data.email != "" &&
      this.prospecttrustedcontact_data.email != null &&
      this.validEmail(this.prospecttrustedcontact_data.email)
    ) {
      this.prospecttrustedcontact_data_errors.email = false;
    } else {
      this.prospecttrustedcontact_data_errors.email = true;
    }

    if (
      this.prospecttrustedcontact_data.birth_date != "" &&
      this.prospecttrustedcontact_data.birth_date != null
    ) {
      this.prospecttrustedcontact_data_errors.birth_date = false;
    } else {
      this.prospecttrustedcontact_data_errors.birth_date = true;
    }

    if (
      this.prospecttrustedcontact_data.gender != "" &&
      this.prospecttrustedcontact_data.gender != null
    ) {
      this.prospecttrustedcontact_data_errors.gender = false;
    } else {
      this.prospecttrustedcontact_data_errors.gender = true;
    }

    if (
      this.prospecttrustedcontact_data.relationship_type != "" &&
      this.prospecttrustedcontact_data.relationship_type != null
    ) {
      this.prospecttrustedcontact_data_errors.relationship_type = false;
    } else {
      this.prospecttrustedcontact_data_errors.relationship_type = true;
    }

    if (
      this.prospecttrustedcontact_data.telephone_number != "" &&
      this.prospecttrustedcontact_data.telephone_number != null
    ) {
      if (
        // this.validatePhoneNumber(this.prospecttrustedcontact_data.telephone_number) &&
        this.prospecttrustedcontact_data.telephone_number.length >= APP_CONSTANTS.PHONE_NUMBER_LENGTH
      ){
        this.prospecttrustedcontact_data_errors.telephone_number = false;
      }else{
        this.prospecttrustedcontact_data_errors.telephone_number = false;
      }
    } else {
      this.prospecttrustedcontact_data_errors.telephone_number = true;
    }

    if (
      this.prospecttrustedcontact_data_errors.first_name == false &&
      this.prospecttrustedcontact_data_errors.last_name == false &&
      this.prospecttrustedcontact_data_errors.telephone_number == false
    ) {
      let payload: any = this.prospecttrustedcontact_data;
      payload.birth_date = moment(payload.birth_date).format();
      if(this.prospecttrustedcontact_data_errors.birth_date == true) {
        delete payload['birth_date']
      }
      if(this.prospecttrustedcontact_data_errors.percentage_allocation == true){
        payload.percentage_allocation = 0
      }


      payload.prospect = this.table_data[this.show_prospecttrustedcontact].id;
      if (this.prospecttrustedcontact_operation_type == 'Add') {
        this.commonService
          .postData('/prospecttrustedcontact', payload)
          .subscribe(
            (res: any) => {
              this.getTableData();
              this.commonService.showToast(
                'success',
                'Trusted Contact Added Successfully.',
              );
              this.closeProspectTrustedContactOperationModal();
            },
            (err) => {
              this.commonService.showToast('error', err.error);
            },
          );
      } else if (this.prospecttrustedcontact_operation_type == 'Edit') {
        this.commonService
          .patch(
            '/prospecttrustedcontact/' + payload.id,
            payload,
          )
          .subscribe(
            (res: any) => {
              this.getTableData();
              this.commonService.showToast(
                'success',
                'Trusted Contact Updated Successfully.',
              );
              this.closeProspectTrustedContactOperationModal();
            },
            (err) => {
              this.commonService.showToast('error', err.error);
            },
          );
      }
    }
  }

    @ViewChild('prospecttrustedcontactDeleteModal') prospecttrustedcontactDeleteModal: TemplateRef<any>;
    private prospecttrustedcontactDeleteModalRef: MatDialogRef<TemplateRef<any>>;

    openDeleteProspectTrustedContact(data) {
      this.prospecttrustedcontact_data = JSON.parse(JSON.stringify(data));
      this.prospecttrustedcontactDeleteModalRef = this.dialog.open(this.prospecttrustedcontactDeleteModal, { disableClose: true });
      this.prospecttrustedcontactDeleteModalRef.afterClosed().subscribe((result) => {
        this.closeProspectTrustedContactDeleteModal();
      });
    }

    closeProspectTrustedContactDeleteModal() {
      this.resetProspectTrustedContactData();
      this.prospecttrustedcontactDeleteModalRef.close();
    }

    deleteProspectTrustedContactData() {
      const payload = [this.prospecttrustedcontact_data.id];
      this.commonService.delete('/prospecttrustedcontact/destroy?ids=' + payload).subscribe(
        (res: any) => {
          this.commonService.showToast(
            'success',
            'Trusted Contact Deleted Successfully.',
          );

          const index = this.table_data[this.show_prospecttrustedcontact].trusted_contact.findIndex(
            (x) => x.id == this.prospecttrustedcontact_data.id,
          );
          this.table_data[this.show_prospecttrustedcontact].trusted_contact.splice(index, 1);

          this.closeProspectTrustedContactDeleteModal();
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
    }

    relationships_list: any = [];
    getRelationships() {
      this.commonService.getData('/relationship?no_page=true/').subscribe(
        (res: any) => {
          this.relationships_list = res;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
    }

	show_prospect_operations: boolean = false;
    prospect_operation_data: any;
    prospect_opration_type: any;
    openProspectOperation(data, type) {
      this.prospect_operation_data =  JSON.parse(JSON.stringify(data));
      this.prospect_opration_type =  JSON.parse(JSON.stringify(type));
      this.show_prospect_operations = true;
    }

    closeProspectOperation(event) {
      this.prospect_operation_data = {};
      this.prospect_opration_type = "";
      this.show_prospect_operations = false;
    }

    updateProspectOperation(event) {
      this.getPageSummary();
      this.prospect_operation_data = {};
      this.prospect_opration_type = "";
      this.show_prospect_operations = false;
    }

	show_bank_customer_operations: boolean = false;
    bank_customer_operation_data: any;
    bank_customer_opration_type: any;
    openBankCustomerOperation(data, type) {
      this.bank_customer_operation_data =  JSON.parse(JSON.stringify(data));
      this.bank_customer_opration_type =  JSON.parse(JSON.stringify(type));
      this.show_bank_customer_operations = true;
    }

    closeBankCustomerOperation(event) {
      this.bank_customer_operation_data = {};
      this.bank_customer_opration_type = "";
      this.show_bank_customer_operations = false;
    }

    updateBankCustomerOperation(event) {
      this.getPageSummary();
      this.prospect_operation_data = {};
      this.bank_customer_opration_type = "";
      this.show_bank_customer_operations = false;
    }

}
